module.exports = __webpack_public_path__ + "media/images/cancel-b235d1cc709706a94c76ee786e58cf66.svg";